import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navItems } from '../data/navigation';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopDropdown, setDesktopDropdown] = useState<string | null>(null);
  const [mobileSubmenu, setMobileSubmenu] = useState<string | null>(null);
  return <header className="sticky top-0 z-50 w-full bg-ardis-green shadow-md" data-id="element-81" data-mp="2rk2t7chd3dbc">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8" data-id="element-82" data-mp="2wjntprc6jtq6">
        <Logo variant="dark" data-id="element-83" data-mp="31cgxocztqy17" />

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="Hoofdnavigatie" data-id="element-84" data-mp="36bl631excrqh">
          {navItems.map((item, i) => <div key={item.label} className="relative" onMouseEnter={() => item.submenu && setDesktopDropdown(item.label)} onMouseLeave={() => item.submenu && setDesktopDropdown(null)} data-id="element-85" data-mp="3b81wk29lji6q" data-mpi={i}>
              <a href={item.href} aria-current={i === 0 ? 'page' : undefined} aria-haspopup={item.submenu ? 'true' : undefined} aria-expanded={item.submenu ? desktopDropdown === item.label : undefined} className={`flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ardis-yellow ${i === 0 ? 'text-ardis-yellow' : 'text-white/90 hover:text-ardis-yellow'}`} data-id="element-86" data-mp="2rkgfxgczahad">
                {item.label}
                {item.submenu && <ChevronDownIcon className={`h-4 w-4 transition-transform ${desktopDropdown === item.label ? 'rotate-180' : ''}`} data-id="element-87" data-mp="1wz9ybjgfdej" />}
              </a>

              {item.submenu && <AnimatePresence data-id="element-88" data-mp="1re38k23sr4j1">
                  {desktopDropdown === item.label && <motion.div initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 8
            }} transition={{
              duration: 0.18
            }} className="absolute left-0 top-full w-52 overflow-hidden rounded-lg bg-white py-2 shadow-xl ring-1 ring-black/5" data-id="element-89" data-mp="1wbcv99zsx236">
                      {item.submenu.map(sub => <a key={sub.label} href={sub.href} className="block px-4 py-2 text-sm text-slate-700 transition-colors hover:bg-ardis-green/5 hover:text-ardis-green focus:outline-none focus-visible:bg-ardis-green/5" data-id="element-90" data-mp="2t3q5vx91ud2t">
                          {sub.label}
                        </a>)}
                    </motion.div>}
                </AnimatePresence>}
            </div>)}
        </nav>

        {/* Mobile toggle */}
        <button type="button" onClick={() => setMobileOpen(v => !v)} aria-label={mobileOpen ? 'Menu sluiten' : 'Menu openen'} aria-expanded={mobileOpen} className="rounded-md p-2 text-white transition-colors hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-ardis-yellow lg:hidden" data-id="element-91" data-mp="153l0795i0846">
          {mobileOpen ? <XIcon className="h-6 w-6" data-id="element-92" data-mp="3gv8hxhpl9lev" /> : <MenuIcon className="h-6 w-6" data-id="element-93" data-mp="3bw5c3v1sbb5u" />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence data-id="element-94" data-mp="22zglw59yqonz">
        {mobileOpen && <motion.nav initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden border-t border-white/10 bg-ardis-green-dark lg:hidden" aria-label="Mobiele navigatie" data-id="element-95" data-mp="230rqg7b8g0g5">
            <div className="space-y-1 px-4 py-3" data-id="element-96" data-mp="1p4waoac4r5gz">
              {navItems.map((item, i) => <div key={item.label} data-id="element-97" data-mp="1t712d3j0ps0z" data-mpi={i}>
                  {item.submenu ? <>
                      <button type="button" onClick={() => setMobileSubmenu(v => v === item.label ? null : item.label)} aria-expanded={mobileSubmenu === item.label} className="flex w-full items-center justify-between rounded-md px-3 py-2.5 text-left text-sm font-medium text-white/90 hover:bg-white/10" data-id="element-98" data-mp="1y1f0hdp2ed9c">
                        {item.label}
                        <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileSubmenu === item.label ? 'rotate-180' : ''}`} data-id="element-99" data-mp="jzhgflqqzej1" />
                      </button>
                      <AnimatePresence data-id="element-100" data-mp="a839wu0dpege">
                        {mobileSubmenu === item.label && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} className="overflow-hidden pl-4" data-id="element-101" data-mp="58qli4tuzzbp">
                            {item.submenu.map(sub => <a key={sub.label} href={sub.href} onClick={() => setMobileOpen(false)} className="block rounded-md px-3 py-2 text-sm text-white/70 hover:bg-white/10 hover:text-ardis-yellow" data-id="element-102" data-mp="38v26pzcy07kv">
                                {sub.label}
                              </a>)}
                          </motion.div>}
                      </AnimatePresence>
                    </> : <a href={item.href} onClick={() => setMobileOpen(false)} aria-current={i === 0 ? 'page' : undefined} className={`block rounded-md px-3 py-2.5 text-sm font-medium hover:bg-white/10 ${i === 0 ? 'text-ardis-yellow' : 'text-white/90'}`} data-id="element-103" data-mp="o5cttrvsuvut">
                      {item.label}
                    </a>}
                </div>)}
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}